window.GameVodPlayer = {
  attach: function (video, url, type) {
    if (type === 'hls' && window.Hls && window.Hls.isSupported()) {
      var hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(video);
      return hls;
    }
    if (type === 'hls' && video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = url;
      return null;
    }
    video.src = url;
    return null;
  }
};
